import { useMotionValueEvent, useScroll } from "framer-motion";
import { useState } from "react";

export type ScrollDirection = "up" | "down";

/**
 * A custom hook that returns the direction of the scroll action.
 * @param scrollThreshold The threshold after which the scroll direction should be calculated.
 * @returns An object containing the scroll direction.
 */
export const useScrollDirection = (
  scrollThreshold = 100
): { scrollDirection: ScrollDirection; isScrollUp: boolean } => {
  const { scrollY } = useScroll();
  const [scrollStatus, setScrollStatus] = useState<{ position: number; direction: ScrollDirection }>({
    position: 0,
    direction: "up",
  });

  useMotionValueEvent(scrollY, "change", (position) => {
    if (position < scrollThreshold) return;
    setScrollStatus((prevState) => ({
      ...prevState,
      position,
      direction: prevState.position > position ? "up" : "down",
    }));
  });

  return { scrollDirection: scrollStatus.direction, isScrollUp: scrollStatus.direction === "up" };
};
